import {SubAPI} from "./SubAPI";
import {FeatureFlag} from "../misc/FeatureFlag";

export class FeatureFlags extends SubAPI {
    list() {
        return this.fetcher.get<FeatureFlagSetting[]>("/api/feature-flags")
    }

    upsert(input: FeatureFlagSetting) {
        return this.fetcher.post("/api/feature-flag", input)
    }
}

export type FeatureFlagSetting = {
    id: number;
    key: FeatureFlag;
    defaultEnabled: boolean;
    archived: boolean;
    updatedAt: string;
    overrides: FeatureFlagUserOverride[];
}

export type FeatureFlagUserOverride = {
    usr: number;
    usrName: string;
    enabled: boolean;
}
